/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Tool_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "A tool was enabled for the organisation." |
*
* @param {Audit_Details_Tool_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_enabled_desc = /** @type {((inputs?: Audit_Details_Tool_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Werkzeug wurde für die Organisation aktiviert.")
	return /** @type {LocalizedString} */ ("A tool was enabled for the organisation.")
});